module.exports = function noop() {}


//////////////////
// WEBPACK FOOTER
// ./node_modules/no-op/index.js
// module id = 764
// module chunks = 0